var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleCountPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pattern",
    width: 209,
    height: 181,
    viewBox: "0 0 209 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.211 132.781H96.479L103.962 48.4966H104.738L112.221 132.781H112.211ZM97.3223 132.006H111.358L104.34 52.9362L97.3223 132.006Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.045 134.08H95.645L103.952 47.2075H104.728L113.035 134.08H113.045ZM96.5077 133.305H112.192L104.35 51.3272L96.5077 133.305Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.966 135.418H94.7246L104.34 42.1182L113.956 135.418H113.966ZM95.5873 134.642H113.103L104.35 49.6984L95.597 134.642H95.5873Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.993 136.794H93.7065L104.35 41.0034L114.993 136.794ZM94.5693 136.018H114.121L104.35 48.0505L94.5789 136.018H94.5693Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.128 138.219H92.563L104.35 39.8398L116.128 138.219ZM93.4354 137.443H115.246L104.34 46.3829L93.4354 137.443Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.398 139.692H91.3032L104.351 38.6187L117.398 139.692ZM92.1853 138.917H116.506L104.341 44.6965L92.1756 138.917H92.1853Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.803 141.204H89.897L104.35 37.3198L118.803 141.204ZM90.7888 140.429H117.901L104.34 42.9711L90.779 140.429H90.7888Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.364 142.765H88.3364L104.35 35.9722L120.364 142.765ZM89.238 141.989H119.462L104.35 41.2163L89.238 141.989Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.099 144.374H86.6016L104.35 34.5566L122.099 144.374ZM87.5225 143.598H121.188L104.35 39.4325L87.5127 143.598H87.5225Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.018 146.032H84.6724L104.35 33.0742L124.028 146.032H124.018ZM85.5933 145.256H123.087L104.34 37.6107L85.5933 145.256Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.16 147.738H82.5303L104.341 31.5229L126.151 147.738H126.16ZM83.4706 146.962H125.23L104.35 35.7396L83.4706 146.962Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.545 149.502H80.1558L104.351 29.9238L128.545 149.502ZM81.1057 148.727H127.595L104.351 33.84L81.1057 148.727Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.181 151.315H77.5088L104.34 28.2466L131.172 151.315H131.181ZM78.4781 150.539H130.222L104.35 31.8913L78.4781 150.539Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.119 153.195H74.5718L104.34 26.5112L134.109 153.195H134.119ZM75.5605 152.419H133.14L104.35 29.9136L75.5605 152.419Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.385 155.124H71.3149L104.35 24.6992L137.385 155.124ZM72.3134 154.349H136.387L104.35 27.869L72.3134 154.349Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.011 157.111H67.6895L104.35 22.8281L141.011 157.111ZM68.7073 156.336H139.993L104.35 25.7749L68.7073 156.336Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.033 159.167H63.6567L104.34 20.8799L145.023 159.167H145.033ZM64.7036 158.391H143.996L104.35 23.6425L64.7036 158.391Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.512 161.279H59.1885L104.35 18.8633L149.512 161.279ZM60.2547 160.504H148.455L104.36 21.4418L60.2644 160.504H60.2547Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.475 163.46H54.2056L104.34 16.7793L154.475 163.46ZM55.3009 162.685H153.389L104.34 19.1833L55.2912 162.685H55.3009Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 165.71H48.6904L104.35 14.6182L160.01 165.71H160ZM49.8051 164.934H158.885L104.34 16.867L49.7955 164.934H49.8051Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.136 168.026H42.5547L42.768 167.493L104.35 12.3784L166.146 168.026H166.136ZM43.6985 167.251H164.993L104.341 14.4916L43.6888 167.251H43.6985Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.96 170.421H35.7397L104.35 10.0718L172.96 170.421ZM36.9126 169.645H171.778L104.34 12.0493L36.9029 169.645H36.9126Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.531 172.883H28.1499L104.34 7.67725L180.531 172.883ZM29.3713 172.107H179.319L104.35 9.52867L29.381 172.107H29.3713Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.954 175.422H19.7456L104.35 5.1958L188.954 175.422ZM20.996 174.647H187.694L104.34 6.95031L20.9863 174.647H20.996Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.309 178.04H10.3916L104.35 2.63672L198.309 178.04ZM11.6905 177.264H197.01L104.35 4.29432L11.6905 177.264Z",
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7 180.744H0L104.35 0L208.7 180.744ZM1.34734 179.968H207.352L104.35 1.56063L1.34734 179.968Z",
    fill: "#1422BD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCountPattern);
export default __webpack_public_path__ + "static/media/people-count-pattern.8344f2f5d1a3520f8aec09fb75059479.svg";
export { ForwardRef as ReactComponent };